"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisteredKeeperAddedAsDriverValidation = void 0;
const journey_services_1 = require("@athena-portal/journey-services");
class RegisteredKeeperAddedAsDriverValidation extends journey_services_1.ValidationMethodBase {
    constructor(props) {
        super();
        this.props = props;
        if (this.props.vehicleIndex == null) {
            throw Error("registeredKeeperAddedAsDriver validation missing 'vehicleIndex' setting");
        }
    }
    validateInput(input, context) {
        if (context && context.interaction && context.interaction.vehicles) {
            const vehicle = context.interaction.vehicles[this.props.vehicleIndex];
            if (!vehicle.driverIds.includes(vehicle.mainDriverId)) {
                const error = this.getErrorMessage(context, "The registered keeper of this vehicle must be a named driver");
                return this.invalidResult(error);
            }
        }
        return this.validResult();
    }
}
exports.RegisteredKeeperAddedAsDriverValidation = RegisteredKeeperAddedAsDriverValidation;
//# sourceMappingURL=RegisteredKeeperAddedAsDriverValidation.js.map